import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import ModalContainer from "../../components/modal/ModalContainer";

import { DialogContent,Divider, DialogActions,Paper, Button, Grid, TextField,Switch} from "@material-ui/core";
import CheckCircle from "@material-ui/icons/CheckCircle";
import ResponsiveTable from "../../components/table/ResponsiveTable";
import moment from "moment"
@inject("agentVenueContactStore", "profileStore", "templateStore")
@observer
class InvoiceDetailsModal extends Component {
    sigCanvas = {};
    state = {
        isLoading: false,
        venueData: undefined
    }


    
    getColumns = () => {
        var columns = []
        if(this.props.hideReadyToPay){
            columns = [
                { key: "date", label: "Gig Date" },
                { key: "time", label: "Time" },
                { key: "description", label: "Description" },
                { key: "fee", label: "Fee" }
            ];
        }else{
            columns = [
                { key: "date", label: "Gig Date" },
                { key: "time", label: "Time" },
                { key: "description", label: "Description" },
                { key: "fee", label: "Fee" },
                ...[{ key: "readyToPayCheck", label: "Ready to Pay", align:"center"}],
            ];
        }
       
        return columns;
       
    };


    onClose = () => {
        this.props.agentVenueContactStore.reset()
        this.props.onClose()
    }


    
    render() {
        var invoice = this.props.invoice
        var currency =  this.props.invoice?.payee?.currency
     
        var bsbTitle = "BSB"
        if(currency === "USD"){
            bsbTitle = "Routing Number"
        }else if(currency === "GBP"){
            bsbTitle = "Sort Code"
        }else if(currency === "NZD"){
            bsbTitle = "Bank Code"
        }
        return (
            <ModalContainer open={this.props.open} onClose={this.onClose} onEntered={this.onEntered} title={this.props.title} coloredDialogTitle={true}>
                <DialogContent>
                    <Paper>
                        <div style={{ overflowX: "auto" }}>
                            { this.props.invoice && this.props.invoice.invoiceDetails && this.props.invoice.invoiceDetails.length ?
                            <ResponsiveTable
                                showToolbar={false}
                                selectable={false}
                                columns={this.getColumns()}
                                rows={this.props.invoice?.invoiceDetails?.map(invoiceDetail => {
                                    var row = {};
                                    row.date = moment.utc(invoiceDetail.date).format("DD MMM YYYY");
                                    row.time = `${moment(invoiceDetail.timeStart, "HH:mm:ss").format("hh:mm a")}-${moment(invoiceDetail.timeEnd, "HH:mm:ss").format("hh:mm a")}`
                                    row.description = invoiceDetail.description
                                    row.fee = invoiceDetail.fee
                                    row.readyToPayCheck =  invoiceDetail.readyToPayCheck === 1?  <div style={{textAlign:"center", width:"100%"}}><CheckCircle style={{ texAlign:"center",color: "green"}} /></div> : null
                                    

                                    return row;
                                })}
                            /> : null
                            }
                        </div>
                    </Paper> 
                    {!this.props.hideReadyToPay ?
                    <table>
          
        <tr>
                <td class="payment-to">
                    {`Bank Account Name: ${invoice?.payeeAccountName}`}
                </td>
            </tr>
            <tr>
                <td class="payment-to">
                    {`${bsbTitle}: ${invoice?.payeeBsb}`}
                </td>
            </tr>
            <tr>
                <td class="payment-to">
                    {`Account Number: ${invoice?.payeeAccountNumber}`}
                </td>
            </tr>
        </table> : null }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onClose}>Close</Button>
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default InvoiceDetailsModal;
